import { StrictMode } from 'react'
import { hydrateRoot, createRoot } from 'react-dom/client'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import '@tandem/ui/typebase.css'
import './global.css'
import { routeTree } from './routeTree.gen'

const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const root = document.getElementById('root')!
const app = (
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
)

if (root.innerHTML.trim() && root.innerHTML.trim() !== '<!--ssr-outlet-->') {
  hydrateRoot(root, app)
} else {
  createRoot(root).render(app)
}
